import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const PostGameFollowNudge = ({ gameId, gameTitle, onDismiss }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);

  const handleDismiss = () => {
    setIsVisible(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  const handleViewRoster = () => {
    navigate(`/games/${gameId}`);
    handleDismiss();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 animate-in slide-in-from-bottom duration-300">
      <div className="bg-white rounded-xl shadow-lg border border-zinc-200 p-4">
        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
            <Users className="h-5 w-5 text-orange-600" />
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-zinc-900 mb-1">
              Follow players you enjoyed running with
            </p>
            <p className="text-xs text-zinc-500 mb-3">
              Connect with teammates from {gameTitle || 'this game'}
            </p>
            
            <Button
              onClick={handleViewRoster}
              size="sm"
              className="h-8 px-4 text-xs bg-orange-600 hover:bg-orange-700"
            >
              View Roster
            </Button>
          </div>

          {/* Dismiss button */}
          <button
            onClick={handleDismiss}
            className="text-zinc-400 hover:text-zinc-600 transition-colors flex-shrink-0"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PostGameFollowNudge;
